export function downloadFile(filename: string, content: string, type: string) {
  const element = document.createElement("a")
  const file = new Blob([content], { type })
  element.href = URL.createObjectURL(file)
  element.download = filename
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}

export function downloadZipFile(filename: string, content: BlobPart, type?: string) {
  const file = content instanceof Blob ? content : new Blob([content], { type })
  const element = document.createElement("a")
  element.href = URL.createObjectURL(file)
  element.download = filename
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
  URL.revokeObjectURL(element.href)
}
